<template lang="pug">
textarea.sv-textarea(
    :placeholder="placeholder"
    :rows="rows"
    :value="value"
    @input="input"
)
</template>

<script>
export default {
  name: 'SvTextarea',

  props: {
    value: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    rows: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    input(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-textarea {
    border: none;
    border-radius: 5px;
    background-color: #f3f3f6;
    resize: none;
    outline: none;
    padding: 12px 20px;
    width: 100%;

    &::placeholder {
        font-size: 14px;
        color: #ADB2C0;
    }

    &:focus {
        box-shadow: 0px 2px 10px rgba(10, 110, 183, 0.15);
        background-color: #fff;
    }
}
</style>
